export function fixedAnchorMenu() {
	const anchorMenu = document.querySelectorAll('.jsFixedAnchorMenu');
	const anchorSection = document.querySelectorAll('.fixed-anchor-menu__section, .fixed-anchor-menu-container__sidemenu');

	if (anchorMenu[0]) {
		console.log('init fixed anchor menu');
		anchorMenu.forEach((menu) => {
			const toggleButton = menu.querySelector('.fixed-anchor-menu__toggle');
			const linkList = menu.querySelector('.fixed-anchor-menu__ul');
			const buttonText = menu.querySelector('.fixed-anchor-menu__toggle-text');

			// Toggle show/hide menu items
			toggleButton.addEventListener('click', () => {
				document.body.classList.add('no-scroll');
				toggleButton.classList.toggle('active');
				toggleButton.setAttribute('aria-expanded', toggleButton.classList.contains('active')); 

				setTimeout(() => {
					document.body.classList.remove('no-scroll');
				}, 300)
			});

			// Default-open when the placement is "sidemenu"
			const isSideMenu = menu.closest('.fixed-anchor-menu-container__sidemenu');
			if (isSideMenu && toggleButton) {
				toggleButton.classList.add('active');
				toggleButton.setAttribute('aria-expanded', 'true');
			}

			// Scroll to element center on click
			function handleClick(event) {
				event.preventDefault();
				const targetId = event.currentTarget.getAttribute('data-target');
				const targetElement = document.getElementById(targetId);

				if (targetElement) {
					const rect = targetElement.getBoundingClientRect();
					const offsetTop = window.scrollY + rect.top;
					const middleOffset = offsetTop - (window.innerHeight / 3) + (rect.height / 3);

					window.scrollTo({
						top: middleOffset,
						behavior: 'smooth'
					});

					// Optional: update URL hash without triggering jump
					history.pushState(null, '', `#${targetId}`);
				}

				// Collapse the dropdown again after picking a section — the
				// sidemenu variant is meant to stay permanently open instead.
				if (!isSideMenu && toggleButton) {
					toggleButton.classList.remove('active');
					toggleButton.setAttribute('aria-expanded', 'false');
				}
			}

			// Build anchor menu for article pages
			if (['article', 'creative', 'case'].includes(document.querySelector('main').getAttribute('data-pagetype'))) {
				const allAnchors = document.querySelectorAll('.rich-text a[id]');

				const sections = Array.from(allAnchors).filter(anchor => {
					const accordion = anchor.closest('.accordion-body');
					if (accordion) {
						const style = window.getComputedStyle(accordion);
						return style.display !== 'none' && style.visibility !== 'hidden';
					}
					return true; // not inside an accordion, include it
				});

				// Populate menu items
				sections.forEach(link => {
					const newLi = document.createElement('li');
					const newAnchor = document.createElement('a');
					newAnchor.href = "#";
					newAnchor.setAttribute('data-target', link.id);
					newAnchor.innerHTML = link.parentElement.textContent;
					newAnchor.addEventListener('click', handleClick);
					newLi.appendChild(newAnchor);
					linkList.appendChild(newLi);
				});

				// Get the active section based on viewport middle.
				// Positions are measured live, so content that changes height (e.g. an opened accordion) is accounted for.
				function getActiveSection() {
					const middleY = window.innerHeight / 2;
			
					for (let i = sections.length - 1; i >= 0; i--) {
						if (middleY >= sections[i].getBoundingClientRect().top) {
							return i;
						}
					}
			
					return -1; // fallback if no match
				}

				// Update link highlighting
				function updateActiveLink() {
					const activeIndex = getActiveSection();
					const links = menu.querySelectorAll(".fixed-anchor-menu__ul li");

					if(activeIndex === -1) {
						buttonText.classList.add('show')
					} else {
						buttonText.classList.remove('show')
					}

					links.forEach((link, index) => {
						link.classList.toggle("active", index === activeIndex);
						if(index === activeIndex) {
							link.style.display = 'inline-block';
						} else {
							link.style.removeProperty('display');
						}
					});
				}

				// Setup scroll listener with requestAnimationFrame throttle
				let ticking = false;
				function onScroll() {
					if (!ticking) {
						window.requestAnimationFrame(() => {
							updateActiveLink();
							ticking = false;
						});
						ticking = true;
					}
				}

					// Init + bind
					updateActiveLink();
					window.addEventListener('scroll', onScroll);
					window.addEventListener('resize', onScroll);
					// Re-mark when the page changes height without scrolling, e.g. when an accordion opens or closes
					if ('ResizeObserver' in window) {
						new ResizeObserver(onScroll).observe(document.querySelector('main'));
					}
				} else {
					;
				}
			});

			// Scroll behavior for fixed menu header
			if (anchorSection) {
				anchorSection.forEach((anchorSection) => {
					const menuElement = document.querySelector('header');
					let oldScrollHeight;
					let height;
	
					function setScrollValues() {
						oldScrollHeight = window.scrollY;
						setTimeout(() => {
							//if double logo menu
							if(document.querySelector('.header--double-logo-sidemenu') && window.innerWidth < 769) {
								height = document.querySelector('.header--double-logo-sidemenu').offsetHeight;
							} else {
								height = menuElement.offsetHeight;
							}
							// console.log('height', height)
						}, 1000)
					}
	
					setScrollValues();
					window.addEventListener('resize', setScrollValues);
	
					let headerTagged = document.querySelector('.header--tagged')
					let headerTransparent = document.querySelector('.header--transparent');
	
				//only apply scroll behavior is header is not fixed to top (tagged and transparent)
				if(!headerTagged && !headerTransparent) {
					window.addEventListener('scroll', () => {
						const newScrollHeight = window.scrollY;
	
						if (oldScrollHeight > newScrollHeight) {
							// Scrolling up
							anchorSection.style.top = height + 'px';
						} else if (oldScrollHeight < newScrollHeight) {
							// Scrolling down
							if(document.querySelector('.header--double-logo-sidemenu') && window.innerWidth < 769) {
								anchorSection.style.top = height + 'px';
							}
							else if (newScrollHeight < height) {
								anchorSection.style.top = height + 'px';
							} else {
								anchorSection.style.top = '0px';
							}
						}
						oldScrollHeight = newScrollHeight;
				});
				}

			})
		}
	}
}

export default fixedAnchorMenu;